import React, { useState, useEffect } from 'react'
import Column from './Column'
import { DragDropContext, DropResult } from 'react-beautiful-dnd'
import { styled } from '../../../stiches.config'
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceDeliveryBaseURL } from '../../../Services/config/apiGateway';
import { REQUESTERFIELDS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
const StyledColumns = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  // margin: '10vh auto',
  // width: '80%',
  //height: '80vh',
  gap: '8px'
})

function DragDrop(props) {
  let tasks = [];
  let fields = [];
  let fieldId = [];
  let madatoryFields = [];
  let optionalFields = [];
  let madatoryId = [];
  let optionalId = [];
  const isEdit = props.isEdit;
  const editValue = props.editValue
  const initialColumns = {
    todo: {
      id: 'todo',
      list: fields,
      fieldId: fieldId
    },
    doing: {
      id: 'doing',
      list: isEdit ? madatoryFields : [],
      fieldId: isEdit ? madatoryId : []
    },
    done: {
      id: 'done',
      list: isEdit ? optionalFields : [],
      fieldId: isEdit ? optionalId : []
    }
  }
  const [columns, setColumns] = useState(initialColumns)


  useEffect(() => {
    console.log(isEdit, editValue)
    if (isEdit) {
      editValue.map(x => {
        if (x.fieldType == "Mandatory") {
          madatoryFields.push(x.fieldName)
          madatoryId.push(x.fieldId)
        }
        else {
          optionalFields.push(x.fieldName)
          optionalId.push(x.fieldId)
        }
      })
    }
    else {
      ApiCall(
        'GET',
        serviceDeliveryBaseURL + REQUESTERFIELDS_ENDPOINT,
        {},
        {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-cc-trace-id': '1234',
        },
      ).then((apiData) => {
        if (apiData.flag != -1) {
          if (apiData.flag == 500) {
            toast("Something went wrong!", { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
          }
          else {
            console.log('I am 200!');
            apiData.map(x => {
              tasks.push({
                field: x.displayName,
                id: x.fieldId
              })
            })
            tasks.forEach((x) => {
              fields.push(x.field);
              fieldId.push(x.id)
            })
          }
        } else {
          // toast("Something went wrong!",{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
      });
    }
  }, [])

  const onDragEnd = ({ source, destination }: DropResult) => {
    // Make sure we have a valid destination
    if (destination === undefined || destination === null) return null

    // Make sure we're actually moving the item
    if (
      source.droppableId === destination.droppableId &&
      destination.index === source.index
    )
      return null

    // Set start and end variables
    const start = columns[source.droppableId]
    const end = columns[destination.droppableId]

    // If start is the same as end, we're in the same column
    if (start === end) {
      // Move the item within the list
      // Start by making a new list without the dragged item
      const newList = start.list.filter(
        (_: any, idx: number) => idx !== source.index
      )

      // Then insert the item at the right location
      newList.splice(destination.index, 0, start.list[source.index])
      const newFieldId = start.fieldId.filter(
        (_: any, idx: number) => idx !== source.index
      )

      // Then insert the item at the right location
      newFieldId.splice(destination.index, 0, start.fieldId[source.index])

      // Then create a new copy of the column object
      const newCol = {
        id: start.id,
        list: newList,
        fieldId: newFieldId
      }

      // Update the state
      setColumns(state => ({ ...state, [newCol.id]: newCol }))
      return null
    } else {
      // If start is different from end, we need to update multiple columns
      // Filter the start list like before
      const newStartList = start.list.filter(
        (_: any, idx: number) => idx !== source.index
      )
      const newStartFieldId = start.fieldId.filter(
        (_: any, idx: number) => idx !== source.index
      )
      // Create a new start column
      const newStartCol = {
        id: start.id,
        list: newStartList,
        fieldId: newStartFieldId
      }

      // Make a new end list array
      const newEndList = end.list
      const newEndFieldId = end.fieldId

      // Insert the item into the end list
      newEndList.splice(destination.index, 0, start.list[source.index])
      newEndFieldId.splice(destination.index, 0, start.fieldId[source.index])

      // Create a new end column
      const newEndCol = {
        id: end.id,
        list: newEndList,
        fieldId: newEndFieldId
      }

      // Update the state
      setColumns(state => ({
        ...state,
        [newStartCol.id]: newStartCol,
        [newEndCol.id]: newEndCol
      }))
      return null
    }
  }

  return (
    <DragDropContext onDragEnd={isEdit ? null : onDragEnd}>
      <StyledColumns>
        {Object.values(columns).map(col => (

          <Column col={col} key={col.id} />

        ),
          props.setFields(columns)
        )}
      </StyledColumns>
    </DragDropContext>
  )
}

export default DragDrop
